import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-dots-button',
  templateUrl: './dots-button.component.html',
  styleUrls: ['./dots-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DotsButtonComponent implements OnInit {
  @Input() disabled = false;
  @Input() activated = false;
  constructor() { }

  ngOnInit(): void {
  }

}
